import { checkMark, trending } from "@/designSystemIcons";
import { cn } from "@/lib/utils";

interface TacticImageProps {
  imageUrl: string;
  author: string;
  isTrending?: boolean;
  noBorder?: boolean;
  selectable?: boolean;
  selected?: boolean;
  onClick?: () => void;
  rounded?: boolean;
  hideAuthors?: boolean;
}
const TacticImage = ({
  imageUrl,
  author,
  isTrending,
  noBorder,
  selectable,
  selected,
  onClick,
  rounded,
  hideAuthors = false,
}: TacticImageProps) => {
  return (
    <div
      className={cn(
        "relative max-h-28 h-full aspect-square bg-black/60 shrink-0",
        !noBorder && "border-gray-800",
        selectable && "cursor-pointer",
        selectable && !selected && "opacity-50 desktop:hover:opacity-100",
        rounded &&
          "touch-device:border-b-2 touch-device:border-l-2 touch-device:border-t-2 touch-device:rounded-l-lg",
      )}
      onClick={onClick}
    >
      <img
        src={imageUrl}
        alt="tactic"
        className={cn("w-full h-full", rounded && "touch-device:rounded-l-md")}
      />
      {selected && (
        <div
          className={cn(
            "absolute top-2 right-2 flex items-center justify-center fill-white h-5 w-5 rounded-full bg-primary-dark-blue",
          )}
        >
          {checkMark}
        </div>
      )}
      <p
        className={cn(
          "absolute bottom-0 w-full text-xs text-center text-dark-tertiary bg-black/80 touch-device:rounded-bl-md",
          hideAuthors && "hidden touch-device:block",
        )}
      >
        {author}
      </p>
      {isTrending && <span className="absolute top-1 left-1">{trending}</span>}
    </div>
  );
};

export default TacticImage;
